import React from 'react';

const buttonStyle = (active) => ({
    padding: '0.25rem 0.9rem',
    border: `1px solid ${active ? '#1779ba' : '#cfd3d9'}`,
    borderRadius: '1rem',
    backgroundColor: active ? '#1779ba' : '#fff',
    color: active ? '#fff' : '#444',
    fontSize: '0.8rem',
    cursor: 'pointer',
    margin: 0,
});

// options: [{ key, label }]
const Toggle = ({ options, value, onChange }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
        {options.map((option) => (
            <button key={option.key} type="button" style={buttonStyle(option.key === value)} onClick={() => onChange(option.key)}>
                {option.label}
            </button>
        ))}
    </div>
);

export default Toggle;
